var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseService, Injectable } from '~/services/service.base';
import { action, makeObservable, observable, toJS } from 'mobx';
export let ServiceOpenChapterItems = class ServiceOpenChapterItems extends BaseService {
    openedItems = {};
    constructor() {
        super();
        makeObservable(this);
    }
    handleOpen = (albumId, params) => (this.self.openedItems = { ...this.self.openedItems, [albumId]: params });
    handleToggle = (albumId, params) => {
        const items = toJS(this.self.openedItems);
        if (items[albumId] && items[albumId]?.chapterId === params.chapterId) {
            delete items[albumId];
            this.self.openedItems = { ...items };
        }
        else {
            this.self.openedItems = { ...this.self.openedItems, [albumId]: params };
        }
    };
    handleClear = () => (this.self.openedItems = {});
};
__decorate([
    observable,
    __metadata("design:type", Object)
], ServiceOpenChapterItems.prototype, "openedItems", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ServiceOpenChapterItems.prototype, "handleOpen", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ServiceOpenChapterItems.prototype, "handleToggle", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], ServiceOpenChapterItems.prototype, "handleClear", void 0);
ServiceOpenChapterItems = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [])
], ServiceOpenChapterItems);
